'use client'
import {handleLogout} from '@/lib/handle-login-logout';
import Link           from 'next/link';
import SessionState   from "@/lib/session-state";

export default function () {
    //
    let interval;

    const onLogout = () => {
        let currentLocation = window.location.href
        clearInterval(interval)
        interval = setInterval(() => {
            SessionState.setLoggedIn(false)
            if (window.location.search === '?logged-out=true') {
                window.location = "/";
            }
        }, 500)

    }


    return (
        <form action={handleLogout} className="w-full">
            <button
                onClick={onLogout}
                type="submit"
                className="flex flex-row justify-content-start items-center w-full cursor-pointer hover:bg-gray-200 p-2 "
            ><i className="mio text-gray-500">logout</i>
                <span className={'ms-3'}>Sign out</span>
            </button>
        </form>
    );


    return (
        <Link
            href="/auth/signout"
            type="submit"
            className="flex flex-row justify-content-start items-center w-full cursor-pointer hover:bg-gray-200 p-2 "
        ><i className="mio text-gray-500">logout</i>
            <span className={'ms-3'}>Sign out</span>
        </Link>
    );
}